import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
import config from "../../config";

const Channel_integrate_new = () => {
  let navigate = useNavigate();
  const { channel_id } = useParams();
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  const [state, setState] = useState({
    name: "",
    url: "",
    key: "",
    password: "",
    store_id: "",
    webhook_url: "",
  });
  const [tempstate, settempState] = useState({
    name: "",
    url: "",
    key: "",
    password: "",
  });

  const [isLoading, setisLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const handleChange = (e) => {
    // let names = e.target.name
    let values = e.target.value;
    setState({ ...state, [e.target.name]: values });
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });

  React.useEffect(() => {
    const randomStoreId = Math.floor(1000000000 + Math.random() * 9000000000); // Generate a 10-digit random number
    const generatedWebhookUrl = `https://backend.kalpcargo.com/webhook/shopify/${randomStoreId}`;
    // setWebhookUrl(generatedWebhookUrl);
    setState({ store_id: randomStoreId, webhook_url: generatedWebhookUrl });
  }, []);

  // const handleSave = () => {
  //     if (!state.name || !state.url) {
  //       Toast.fire({ icon: "error", title: "Please enter Store Name & Store URL" });
  //       return;
  //     }

  //     // Redirect to backend for OAuth
  //     window.location.href = `https://backend.kalpcargo.com/auth?shop=${state.url}&store_id=${state.store_id}&store_name=${state.name}&customer_id=${userData.customer_id}`;
  //   };

  const handleSave = () => {
    // Open your custom HTML page
    window.location.href = "/add_store_page.html";
  };
  return (
    // <div>
    //     <Header />
    //     <div class="page-wrapper pinned">
    //         <div class="main-container">
    //             <div className='app-container'>
    //                 <div class="app-body">
    //                     <div class="container-fluid">

    //                             <section class="mb-3 mt-3 shopify">
    //                                 <div class="container">
    //                                     <h3 class="py-3">Integrate Shopify</h3> Before integrating your store, please ensure you create a pickup point/ warehouse first from Left Side Menu Warehouse
    //                                        <div class="row mt-4 mb-3">
    //                                         <div class="col-12 col-md-5">
    //                                             {/* <figure>
    //                                                 <img src="../../../assets/img/shopify.png" class="img-fluid" style={{ height: "100px" }} />
    //                                             </figure> */}

    //                                             <h5>Shopify</h5>
    //                                           </div>
    //                                         <div class="col-12 col-md">

    //                                             <div class="card border-0 shadow-sm mb-3">
    //                                                 <div class="card-body">
    //                                                 <figure>
    //                                                 <img src="../../../assets/img/shopify.png" class="img-fluid" style={{ height: "100px" }} />
    //                                             </figure>
    //                                                     {/* <h6 class="pb-4">Setting</h6> */}
    //                                                     {/* <div class="row">

    //                                                         <div class="col-12 col-md-12 mb-3">
    //                                                             <label for="email" class="form-label">Store Name:</label>
    //                                                             <input type="text" class="form-control" id="" placeholder="Enter Name" name="name" onChange={(e) => handleChange(e)} />
    //                                                         </div>
    //                                                            <div class="col-12 col-md-12 mb-3">
    //                                                             <label for="email" class="form-label">Store URL:</label>
    //                                                             <input type="text" class="form-control" id="" placeholder="yourstorename.myshopify.com" name="url" onChange={(e) => handleChange(e)} />
    //                                                         </div>

    //                                                     </div> */}

    //                                                     <div class="py-4">

    //                                                             <a onClick={handleSave} class="btn btn-primary">Save & Test Integration</a>

    //                                                     </div>
    //                                                 </div>
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </section>

    //                     </div>
    //                 </div>
    //                 <Footer />
    //             </div>
    //         </div>
    //     </div>
    // </div>
    <div className="bg-light min-vh-100 d-flex flex-column">
      <div className="container flex-grow-1 d-flex align-items-center justify-content-center py-5">
        <div className="text-center">
          {/* Image */}
          <div className="mb-4">
            <img
              src="https://i.ibb.co/F4Srr0J7/add-1.png"
              className="img-fluid"
              alt="Add Store"
              style={{ maxHeight: "400px" }}
            />
          </div>

          {/* Heading */}
          <h1 className="display-5 fw-semibold mb-3">Add Store</h1>

          {/* Subtitle */}
          <p className="lead text-muted mb-4">
            Click the below button to add a new store.
          </p>

          {/* Button */}
          <a
            href="https://apps.shopify.com/kalpcargo"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-lg px-4 py-2"
          >
            Add Your Store
          </a>
        </div>
      </div>
    </div>
  );
};

export default Channel_integrate_new;
